import { Paper, styled } from '@mui/material';
import Modal from 'components/Modal';

export const StyledGradeBookTisModal = styled(Modal)({
	'& .MuiDialog-paper': {
		maxWidth: '500px',
	},
});

export const StyledGradeBookTisModalPaper = styled(Paper)({
	padding: '8px',
	borderRadius: '16px',
});
